/**
 * theme.js
 *
 * Configuration Ant Design pour le mode nuit/jour
 * Retourne les tokens de thème pour ConfigProvider
 */

export const getLightTheme = () => ({
    token: {
        colorPrimary: "#1890ff",
        colorBgBase: "#ffffff",
        colorTextBase: "#000000",
        borderRadius: 6,
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
    },
    algorithm: undefined, // Light theme par défaut
});

export const getDarkTheme = () => ({
    token: {
        colorPrimary: "#177ddc", // Bleu ajusté pour dark mode
        colorBgBase: "#141414",
        colorTextBase: "#ffffff",
        borderRadius: 6,
        colorBgContainer: "#1f1f1f",
        colorBorder: "#434343",
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
    },
    algorithm: require("antd/es/theme").darkAlgorithm, // ✅ DARK MODE
});

/**
 * Retourne la configuration du thème basée sur le mode
 * @param {boolean} isDarkMode - true pour dark, false pour light
 * @returns {Object} Configuration Ant Design
 */
export const getThemeConfig = (isDarkMode) => {
    return isDarkMode ? getDarkTheme() : getLightTheme();
};